import React, { useEffect, useMemo } from 'react';
import { View, StyleSheet, Text, ScrollView, useWindowDimensions } from 'react-native';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { useDispatch, useSelector } from 'react-redux';
import { getCleanUrl } from '../../utils/Helper';
import { ImageComp } from '../../components/Image/Image';
import { useCssStyle } from '../../customHook/getCssStyle';
import { CHECK, CHECK_CIRCLE, KEY_ICON, SUCCESS_CHECK } from '../../assets';
import CustomPressable from '../../components/customPressable/customPressable';
import { makeLayoutApiCalls } from '../../js/fetchAppConfigs';
import { useNavigation } from '@react-navigation/native';
import { setGoHome } from '../../Redux/Reducers/appConfigReducer';
import { setProceedLoginToTheApp } from '../../Redux/Actions/appConfigAction';
import { useTranslation } from 'react-i18next';
import RenderHTML from 'react-native-render-html';

const CheckInSuccess = ({ checkedInGuestDetails }) => {

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const navigation = useNavigation();
    const { width } = useWindowDimensions();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const imgUrl = getCleanUrl(currentWidget?.widgetHeaderImageUrl);

    const { doorKeyType } = useSelector((state) => state.appConfigSlice);

    const handleContinueMyStay = () => {
        dispatch(setGoHome(true));
    }


    useEffect(() => {

        return () => {
            dispatch(setProceedLoginToTheApp(true, { lastName: checkedInGuestDetails.lastName, confirmationNumber: checkedInGuestDetails.confirmationNumber, checkinDate: checkedInGuestDetails.checkinDate, roomNumber: checkedInGuestDetails.roomNumber, candoAccompanyLogin: false, candoOtpFlow: false }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    const customWidgetHeaderTitleStyle = useMemo(() => {
        const style = getStyles(['widgetmainContainerHeaderTitle', 'checkInSuccessHeaderTitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const customWidgetHeaderSubTitleStyle = useMemo(() => {
        const style = getStyles(['widgetmainContainerHeaderSubTitle', 'checkInSuccessHeaderSubTitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isFontTitleArray = useMemo(() => Array.isArray(customWidgetHeaderTitleStyle?.fontFamily), [customWidgetHeaderTitleStyle]);
    const isFontSubTitleArray = useMemo(() => Array.isArray(customWidgetHeaderSubTitleStyle?.fontFamily), [customWidgetHeaderSubTitleStyle]);

    return (
        <View style={getStyles(['widgetRootContainer', 'checkInSuccessRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleContinueMyStay} />

            <ScrollView contentContainerStyle={getStyles(['widgetmainContainer', 'checkInSuccessMainContainer'])} showsVerticalScrollIndicator={false}>

                <View style={getStyles(['widgetmainContainerHeaderContainer', 'checkInSuccessHeaderContainer'])}>
                    {imgUrl && <ImageComp source={getCleanUrl(imgUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'checkInMainContainerHeaderImg'])} id="widgetmainContainerHeaderImg checkInMainContainerHeaderImg" />}
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'checkInSuccessMainContainerChildContainer', !imgUrl && { justifyContent: "center" }])} id='checkInSuccessMainContainerChildContainer'>
                    {!imgUrl && <View style={getStyles(['checkInSuccessContainerHeaderImgContainer'])}>
                        <View style={getStyles(['checkInSuccessContainerHeaderImgBackground'])}>
                            <ImageComp 
                                source={CHECK_CIRCLE} 
                                style={getStyles(['checkInSuccessContainerHeaderImg'])} 
                                id="checkInSuccessContainerHeaderImg"
                            />
                        </View>
                    </View>}

                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'checkInSuccessHeaderTitleContainer'])}>
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={isFontTitleArray ? {...customWidgetHeaderTitleStyle, fontFamily: null} : customWidgetHeaderTitleStyle}
                            source={{ html: t('check_in.checkin_success.heading')?.replace("#ROOMNUMBER", checkedInGuestDetails.roomNumber) }}
                            systemFonts={isFontTitleArray ? customWidgetHeaderTitleStyle?.fontFamily : [customWidgetHeaderTitleStyle.fontFamily]}
                            id={`widgetmainContainerHeaderTitle checkInSuccessHeaderTitle`}
                        />

                        {t('check_in.checkin_success.sub_heading') && 
                            <RenderHTML
                                contentWidth={width}
                                baseStyle={isFontSubTitleArray ? {...customWidgetHeaderSubTitleStyle, fontFamily: null} : customWidgetHeaderSubTitleStyle}
                                source={{ html: t('check_in.checkin_success.sub_heading')}}
                                systemFonts={isFontSubTitleArray ? customWidgetHeaderSubTitleStyle?.fontFamily : [customWidgetHeaderSubTitleStyle.fontFamily]}
                                id={`widgetmainContainerHeaderSubTitle checkInSuccessHeaderSubTitle`}
                            />
                        }
                    </View>

                    <View style={getStyles(['checkInSuccessMainContainerChildContainer_textContainer'])}>

                        <Text style={getStyles(['checkInSuccessMainContainerChildContainer_infotext'])}>{t('check_in.checkin_success.info_text')}
                            <Text style={getStyles(['checkInSuccessMainContainerChildContainer_infotext_roomnumber'])}>{checkedInGuestDetails.roomNumber}</Text> 
                        </Text>

                        <Text style={getStyles(['checkInSuccessMainContainerChildContainer_subinfotext'])}>
                            {doorKeyType && doorKeyType != "" ? (
                                <>
                                {t('check_in.digital_key_msg1')}
                                <ImageComp
                                    source={KEY_ICON}
                                    id='GenericDoorkeyImage'
                                    style={getStyles(['autoLoginGenericDoorkeyImage'])}
                                />
                                {t('check_in.digital_key_msg2')}
                                </>
                                ) : (
                                    t('check_in.key_from_desk')
                                )}
                        </Text>
                    </View>
                </View>
            </ScrollView>

            <View style={getStyles(['checkInSuccessFooterContainer'])} id='checkInSuccessFooterContainer'>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleContinueMyStay}>
                    <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.checkin_success.primary_button')}</Text>
                </CustomPressable>
            </View>
        </View>
    );
};
export default CheckInSuccess;
